import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import Classes from '../../../../common/Classes';
import { Helmet } from 'react-helmet';
import { VIDYARD_CONFIG } from '../../../../common/Constants';
import { trackImpressions } from '../../../../common/MixpanelHelper';
import mixpanelConstants from '../../../../common/mixpanelConstants';

const ProductVideoInOverLay = ({ videoId, autoplay, mixpanelProps, productIndex }) => {
  const productRef = useRef(null);
  const mixpanelProperties = {
    ...mixpanelProps,
    component: mixpanelConstants.component.exhibitorDirectoryOverlay, 
    viewedElement: mixpanelConstants.element.productVideo
  }

  useEffect(() => {
    delete mixpanelProperties.element;

    let timeoutId;
    const observer = trackImpressions(mixpanelConstants.eventName.productImpression, mixpanelProperties, 0.8);

    if (productRef.current) {
      timeoutId = setTimeout(() => {
        observer.observe(productRef.current);
      }, 500);
      return () => {
        clearTimeout(timeoutId);
        observer.disconnect();
      };
    }

  }, [productIndex]);

  return (<div className={Classes.productVideoInOverLay} ref={productRef}>
    <Helmet>
      <script async src={VIDYARD_CONFIG.playerScriptUrl} type="text/javascript"  />
    </Helmet>
    <MediaQuery minWidth={1199}>
      <img
        className={'vidyard-player-embed'}
        data-uuid={videoId}
        data-width="890"
        data-height="500"
        data-v="4"
        data-type="inline"
        data-muted='1'
        data-autoplay={autoplay ? '1' : '0'}></img>
    </MediaQuery>
    <MediaQuery minWidth={992} maxWidth={1198}>
      <img
        className={'vidyard-player-embed'}
        data-uuid={videoId}
        data-width="768"
        data-height="432"
        data-v="4"
        data-type="inline"
        data-muted='1'
        data-autoplay={autoplay ? '1' : '0'}></img>
    </MediaQuery>
    <MediaQuery minWidth={768} maxWidth={991}>
      <img
        className={'vidyard-player-embed'}
        data-uuid={videoId}
        data-width="601"
        data-height="338"
        data-v="4"
        data-type="inline"
        data-muted='1'
        data-autoplay={autoplay ? '1' : '0'}></img>
    </MediaQuery>
  </div>)
};


ProductVideoInOverLay.propTypes = {
  videoId: PropTypes.string.isRequired,
  autoplay: PropTypes.bool.isRequired,
  mixpanelProps: PropTypes.object,
  productIndex: PropTypes.number
};

export default ProductVideoInOverLay;
